// extracted by mini-css-extract-plugin
module.exports = {"users":"List_users__SPpQt","totalUsers":"List_totalUsers__HcI_b","number":"List_number__1xHbq","totalContainer":"List_totalContainer__Gg6bv"};